
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42.23 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.476 6.259h-2.672v8.659h5.818v-2.433h-3.146zM39.929 6.308l-1.945 2.9-1.945-2.9s-1.47-.02-2.3-.02l2.986 5.21v3.41h2.515v-3.41l2.99-5.213c-.831.003-2.301.023-2.301.023zM24.625 9.664a3.493 3.493 0 00-3.445-3.479h-4.1v8.732h2.545v-1.769h1.56a3.494 3.494 0 003.44-3.479zm-2.295.291a.81.81 0 01-.842.893h-1.863v-2.2h1.868a.81.81 0 01.842.893z"}}),_c('path',{attrs:{"d":"M10 5.001v8.064a4.935 4.935 0 01-4.936 4.936h-.13a4.935 4.935 0 010-9.87h1.407v-3.13z","fill":"#19c9e9"}}),_c('path',{attrs:{"d":"M3 13.001V4.937A4.935 4.935 0 017.936.001h.13a4.935 4.935 0 010 9.87H6.659v3.13z","fill":"#8d0df5","opacity":".73"}})])
          )
        }
      }
    